/** `m:ss` for a voice's length or the time heard of it. */
export function formatVoiceDuration(seconds: number): string {
  const total = Math.max(0, seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}
